import * as React from 'react';
import Svg, { SvgProps, Path, Circle } from 'react-native-svg';

const ConnectorIcon = (props: SvgProps) => <Svg
  {...props}
  width='11'
  height='85'
  viewBox='0 0 11 85'
  fill='none'
>
  <Path
    d='M1 0V43C1 45.2091 2.79086 47 5 47V47'
    stroke='#B0CBE6'
  />
  <Circle
    cx='8'
    cy='47'
    r='3'
    fill='#B0CBE6'
  />
</Svg>;

export default ConnectorIcon;
